import React, { useContext, useEffect, useState } from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
// import Dashboard from 'components/dashboards/default';
import NavbarTop from "../components/navbar/top/NavbarTop";
import NavbarVertical from "../components/navbar/vertical/NavbarVertical";
//import NavbarVertical from '../components/navbar/vertical/NavbarVertical';
//import AppContext from 'context/Context';
import { useDispatch, useSelector } from "react-redux";
import MainRoutes from "./MainRoutes";
import { Modal } from "antd";
import { getBrokers } from "../api/authentication";
import {
  deleteCookieCredentials,
  setLocalStorageObject,
  getLocalStorageObject,
  isEmptyObject,
  isBanList,
  isEntrantsList,
  isExitList,
  sessionExpireHandle
} from "../util/helper";
import {
  getInstruments,
  getExpiries,
  getPrice,
  getOptionChainInstrumentsData,
  saveSpotPrice
} from "../redux/actions/optionChain";
import { topHeaderAction, getjwtAction, getMwplandBanList, specialSession, basketAction, getSuscriptions, saveTradeFeedSource, saveSockSource, getAllBrokersList } from "../redux/actions/brokerAction";
import Centrifuge from "centrifuge";
import SettingsToggle from '../components/settings-panel/SettingsToggle'
import ModalComponent from '../components/common/modal'
import 'alertifyjs/build/css/alertify.css';
import moment from "moment";
import ConfirmModal from "../components/utilities/confirm-modal";
import BrokerService from "../services/broker.service";
import AppContext from "../context/Context";
import { setSubscriptions } from "../redux/actions/packageAction";
import LandingDev from "components/pages/landing/LandingDev";
import { useToast } from "components/common/custom-toast/Toast";
import TrialStatusModal from "../components/pages/pricing/TrialStatusModal";
import BrokerPurposeModal from "../components/common/BrokerPurposeModal";

const optionsTradingType = ["Live"];

let localStorageObj = getLocalStorageObject("global-top-header") || {
  info: {},
};
const exchange = "NSE";

const initial = {
  selectedBroker: "",
  brokerID: "",
  optionsTradingType: "Live",
  instrument: "",
  instrumentToken: "",
  selectExpiry: "",
  broker: {},
  lotSize: "",
  volumeFreeze: "",
  expires: []
};
const modalContent = [
  "9 out of 10 individual traders in Equity, Futures & Options segment incurred net losses.",
  "On an average, loss makers registered net trading loss close to ₹ 50,000.",
  "Over and above the net trading losses incurred, loss makers expended an additional 28% of net trading losses at transaction costs.",
  "Those making net trading profits, incurred between 15% to 50% of such profits as transaction cost.",
];

const additionalInfo =
  "SEBI study dated January 25, 2023, on “Analysis of Profit and Loss of Individual Traders dealing in equity Futures and Options (F&O) Segment”, wherein Aggregate Level findings are based on annual Profit/Loss incurred by individual traders in equity F&O during FY 2021-22.";

const MainLayout = () => {
  const dispatch = useDispatch();

  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const socketJWT = useSelector((state) => state.socketJwt?.data);
  const tradeFeedSource = useSelector((state) => state.tradeFeedSource?.source);
  const basket = useSelector((state) => state.basket.data);
  const user = useSelector((state) => state.user);
  const [brokerList, setbrokerList] = useState([]);
  const [defBrokere, setdefBrokere] = useState([]);
  const [brokerID, setbrokerID] = useState([]);
  const [instrumentOptions, setInstrumentOptions] = useState([]);
  const [expiryOptions, setExpiryOptions] = useState([]);
  const [spotToken, setSpotToken] = useState();
  const [futToken, setFutToken] = useState();
  const [source, setSource] = useState(() => { });
  const [price, setPrice] = useState();
  const [formData, setformData] = useState(initial);
  const [selectedBroker, setselectedBroker] = useState('');
  const [broker, setbroker] = useState({});
  const [instrument, setinstrument] = useState('');
  const [selectExpiry, setExpiry] = useState('');
  const [displayPopUp, setDisplayPopUp] = useState(false);
  const [volumeFreeze, setvolumeFreeze] = useState('');
  const [lotSize, setlotSize] = useState('');
  const [show, setShow] = useState(false);
  const [storeInstrument, setstoreInstrument] = useState("");
  const [fnoMwpData, setFnoMwpData] = useState({});
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    config: { isDark }
  } = useContext(AppContext);
  const brokersList = useSelector((state) => state.brokers.list)
  const toast = useToast()
  const activePlans = useSelector((state) => state.packages.activePlans);
  const location = useLocation();
  const [expiryModalSeen, setExpiryModalSeen] = useState(false);
  const [trialExpiryInfo, setTrialExpiryInfo] = useState({
    open: false,
    type: "",
    expiryDate: "",
    productName: "QuikTrade"
  });
  const [showBrokerPurposeModal, setShowBrokerPurposeModal] = useState(false);

  useEffect(() => {
    const centrifuge = new Centrifuge(process.env.REACT_APP_API_FEED);

    centrifuge.on("connect", function (ctx) {
      console.log(
        "Connected with client ID " + ctx.client + " over " + ctx.transport
      );
    });

    centrifuge.on("disconnect", function (ctx) {
      console.log(
        "Disconnected: " +
        ctx.reason +
        (ctx.reconnect? "(will reconnect)" : "(won't reconnect)")
      );
    });

    centrifuge.connect();
    setSource(centrifuge);
    dispatch(saveSockSource(centrifuge));
  }, []);

  useEffect(() => {
    if (!socketJWT || !socketJWT.token) return;

    const c = new Centrifuge(process.env.REACT_APP_API_TRADE_FEED, {
      debug: true,
      onRefresh: function (ctx, cb) {
        (async () => {
          try {
            const token = await dispatch(getjwtAction());
            const nextToken = token?.token || (token && token.jwt) || (token && token.accessToken);
            if (nextToken) {
              cb({ token: nextToken });
            } else {
              cb({});
            }
          } catch (e) {
            cb({});
          }
        })();
      }
    });
    c.setToken(socketJWT.token);
    c.on("connect", ctx => {
      console.log("[Trade] connected", ctx.client);
    });

    c.on("disconnect", ctx => {
      console.log(
        "[Trade] disconnected:",
        ctx.reason,
        ctx.reconnect ? "(will reconnect)" : "(won't reconnect)"
      );
    });
    c.connect();
    dispatch(saveTradeFeedSource(c));

    return () => {
      try {
        c.disconnect();
      } catch (e) {
        console.error("[Trade] disconnect error on cleanup", e);
      }
    };
  }, [socketJWT]);

  function getSubscriptions() {
    BrokerService.getSuscriptions().then(
      response => {
        if (response.code === 200 && response?.data) {
          const jsonData = response?.data?.payments;
          dispatch(setSubscriptions(jsonData));
        } else {
          console.error('Invalid API response:', response);
        }
      },
      error => {
        console.error('API error:', error);
      }
    );
  };


  useEffect(() => {
    if (!isLoggedIn) {
      const fnotraderUserid = getQueryStringValue("Fnotrader-Userid");
      const fnotraderSecret = getQueryStringValue("Fnotrader-Secret");
      if (fnotraderUserid && fnotraderSecret) {
        sessionStorage.setItem("fnotraderUserid", fnotraderUserid);
        sessionStorage.setItem("fnotraderSecret", fnotraderSecret);
        window.open("/broker-login", "_self");
      }
    } else {
      getBrockerAccountList();
      getSubscriptions();
      (async () => {
        try {
          await dispatch(getAllBrokersList());
        } catch (e) { }
      })();
      async function getNames() {
        const data = await dispatch(getInstruments());
        if (data && data?.sessionExpired) {
          sessionExpireHandle();
          return
        }

        if (data) {
          setInstrumentOptions(
            data?.map((instrument) => instrument.tradingName)
          );

          if (getLocalStorageObject("global-top-header")?.info?.instrument) {
            setinstrument(getLocalStorageObject("global-top-header")?.info?.instrument)

          } else {
            setinstrument(data[1].tradingName)

          }
        }
      }
      var isFlag = false;
      async function getToken() {
        await dispatch(getjwtAction());
      }
      if (!isFlag) {
        isFlag = true;
        getToken();

      }


      getNames();

      const popDate = localStorage.getItem("seenPopUpDate");
      if (popDate) {
        const oldDate = moment(new Date()).format("YYYY-MM-DD");
        const currentDate = moment(new Date()).format("YYYY-MM-DD");
        if (oldDate !== currentDate) {
          setDisplayPopUp(true);
        }
      } else {
        setDisplayPopUp(true);
      }
      async function getspecialSession() {
        const ssres = await specialSession();
        if (ssres && ssres?.sessionExpired) {
          sessionExpireHandle();
        } else if (!isEmptyObject(ssres) && ssres["NFO"]) {
          localStorage.setItem("specialSession", JSON.stringify(ssres["NFO"]));
        }
      }

      async function getMwplandBanListReq() {
        const res = await getMwplandBanList(new Date().toISOString().split("T")[0]);
        if (res && res?.sessionExpired) {
          sessionExpireHandle();
          return;
        }

        if (res) {
          setFnoMwpData(res);
        }
      }

      getspecialSession();
      getMwplandBanListReq();

      // Load basket from local storage on mount
      const savedData = getLocalStorageObject("basket");
      if (savedData && savedData.basket && savedData.basket.length > 0) {
        dispatch(basketAction(savedData.basket));
      }
    }
  }, []);

  useEffect(() => {
    async function fetchExpiries() {
      const data = await dispatch(getExpiries(instrument));
      if (data && data?.sessionExpired) {
        sessionExpireHandle();
      }

      if (data) {
        setExpiryOptions(data);
        setExpiry(data[0]);
      }
    }


    if (instrument) {
      fetchExpiries();
    }
  }, [instrument]);

  useEffect(() => {
    async function fetchPrice() {
      setPrice();
      const data = await getPrice(
        instrument,
        instrument === "SENSEX" || instrument === "BANKEX"
          ? "BSE"
          : exchange,
        spotToken
      );
      if (data && data?.sessionExpired) {
        sessionExpireHandle();
      }

      const { lp, token } = data;
      if (lp && token) {
        setPrice(lp);
        setSpotToken(token);
      }
    }

    if (instrument) {
      fetchPrice();
    }
  }, [instrument]);

  useEffect(() => {


    if (broker && selectedBroker && brokerID && instrument && expiryOptions.length > 0) {
      initial.selectedBroker = selectedBroker;
      initial.broker = broker;
      initial.brokerID = brokerID;
      initial.instrument = instrument;
      initial.selectExpiry = selectExpiry;
      initial.instrumentToken = spotToken;
      initial.volumeFreeze = volumeFreeze
      initial.lotSize = lotSize
      initial.expires = expiryOptions
      setLocalStorageObject(
        "global-top-header",
        "info",
        initial,
        localStorageObj
      );

      dispatch(topHeaderAction(initial));
    }




  }, [
    brokerID,
    instrument,
    selectExpiry,
    spotToken,
    selectedBroker,
    broker,
    volumeFreeze,
    lotSize,
    dispatch,
    expiryOptions
  ]);

  useEffect(() => {
    async function fetch() {
      const data = await getBrokers("loggedIn");
      if (data?.data?.brokers?.length > 0) {
        const terminalBrokers = data?.data?.brokers?.filter((item) => item.purpose !== 'algo');
        const brokers = terminalBrokers?.filter((item) => item.quickTrade).map((item) => item);
        const brokeruserName = terminalBrokers?.filter((item) => item.quickTrade).map(
          (item) => item.userName
        );
        setbrokerList(terminalBrokers);
        setdefBrokere(brokers);
        setbrokerID([brokeruserName[0]]);

        const savedBroker = localStorage.getItem("lastSelectedBroker");
        let initialBroker = brokers[0];

        if (savedBroker) {
          const found = brokers.find(b => {
            const typeValue = b.type === "xts" ? b.subType.toUpperCase() + ' ' + (b.type.toUpperCase()) : b.type;
            return typeValue === savedBroker;
          });
          if (found) {
            initialBroker = found;
          }
        }

        if (initialBroker) {
          if (initialBroker.type === "xts") {
            setselectedBroker(initialBroker.subType.toUpperCase() + ' ' + (initialBroker.type.toUpperCase()));
          } else {
            setselectedBroker(initialBroker.type);
          }
          setbroker(initialBroker);
          setbrokerID([initialBroker.userName]);
        }
      }
    }
    fetch();

  }, [brokersList]);

  useEffect(() => {
    async function fetchOptionChainInstruments() {
      const res = await dispatch(getOptionChainInstrumentsData(instrument, selectExpiry));
      if (res) {

        const { optData, futToken: futTkn, lotSize, volumeFreeze } = res;

        setvolumeFreeze(volumeFreeze);
        console.log(lotSize)
        setlotSize(lotSize)
        if (futTkn) {
          setFutToken(futTkn);
        }
      }
    }

    if (instrument && selectExpiry) {
      fetchOptionChainInstruments();
    }
  }, [instrument, selectExpiry]);



  const getQueryStringValue = (name) => {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
  };

  const getBrockerAccountList = async () => { };

  const onSelectBoker = async (value) => {

    const filter = brokerList.filter((item) => item.type.toLowerCase() === value.toLowerCase());

    if (filter.length === 0) {
      let index = value.indexOf("XTS");
      if (index >= 0) {
        const filterSub = brokerList.filter((item) => item.subType.toLowerCase() === value.split(' ')[0].toLowerCase());

      setbrokerID([filterSub[0]?.userName]);
      setselectedBroker(value);
      setbroker(filterSub[0]);
      localStorage.setItem("lastSelectedBroker", value);
    }

  } else {
    setbrokerID([filter[0]?.userName]);
    setselectedBroker(value);
    setbroker(filter[0]);
    localStorage.setItem("lastSelectedBroker", value);
  }

  };

  const getRealSpotprice = (price) => {
    setPrice(price);
    dispatch(saveSpotPrice(price));

  };


  const handleInstrumentChange = (e) => {

    if (basket && basket.length > 0) {

      setShow(true);
      setstoreInstrument(e)
      return;
    }

    setinstrument(e)
    setExpiry("");
    if (fnoMwpData && Object.keys(fnoMwpData).length > 0) {
      const isBan = isBanList(fnoMwpData.banList, e);

      if (isBan.length > 0) {
        toast.error(e + " is in BAN List");
        return
      }

      const isEntrants = isEntrantsList(fnoMwpData.entrantsList, e);

      if (isEntrants.length > 0) {
        toast.error(e + " is in Entrants List");
        return
      }
      const isExit = isExitList(fnoMwpData.exitsList, e);

      if (isExit?.length > 0) {
        toast.error(e + " is in Exits List");
        return
      }
    }

  }
  const handleExpiryChange = (e) => {
    setExpiry(moment(e).format("YYYY-MM-DD"))
  }

  const closePopUp = () => {
    // setting key "seenPopUp" with value true into localStorage
    localStorage.setItem("seenPopUpDate", new Date());
    // setting state to false to not display pop-up
    setDisplayPopUp(false);
  };

  const onClickHandle = () => {

    setinstrument(storeInstrument);
    setShow(false);
    dispatch(basketAction([]));

    //  dispatch(getMarginAction(info?.broker?.id, {orders:[]}));
  };

  useEffect(() => {
    const isTradingZone = location.pathname.includes('/terminal') || location.pathname.includes('/algo');
    if (isLoggedIn && !displayPopUp && isTradingZone && !expiryModalSeen && activePlans?.length > 0) {
      const expiringPlan = activePlans.find(plan => plan.daysRemaining < 2);

      if (expiringPlan) {
        setTrialExpiryInfo({
          open: true,
          type: expiringPlan.daysRemaining <= 0 ? 'expired' : 'ending',
          expiryDate: expiringPlan.packageEndTime,
          productName: expiringPlan.planName
        });
        setExpiryModalSeen(true);
      }
    }
  }, [location.pathname, displayPopUp, activePlans, isLoggedIn, expiryModalSeen]);

  // Check for brokers without purpose set
  useEffect(() => {
    if (brokersList?.length > 0) {
      const unpurposed = brokersList.filter(b => b.type !== 'papertrading' && (!b.purpose || b.purpose === ""));
      if (unpurposed.length > 0) {
        setShowBrokerPurposeModal(true);
      }
    }
  }, [brokersList]);




  return (
    <div className={"container-fluid cf-main"}>
      <NavbarTop
        defBrokere={defBrokere}
        brokerID={brokerID}
        optionsTradingType={optionsTradingType}
        instrumentOptions={instrumentOptions}
        expiryOptions={expiryOptions}
        spotToken={spotToken}
        futToken={futToken}
        source={source}
        getRealSpotprice={getRealSpotprice}
        selectedBroker={selectedBroker}
        setselectedBroker={onSelectBoker}
        instrument={instrument}
        handleInstrumentChange={handleInstrumentChange}
        selectExpiry={selectExpiry}
        handleExpiryChange={handleExpiryChange}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
      />
      <NavbarVertical isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <div style={{ colorScheme: isDark ? 'dark' : 'light' }} className="content">
        <MainRoutes />
        {/* <SettingsToggle/> */}
        <div>
          {displayPopUp && (
            <ModalComponent
              open={displayPopUp}
              onClose={closePopUp}
              title="Risk Disclosures on Derivatives"
              content={modalContent}
              additionalInfo={additionalInfo}
            />
          )}
        </div>
      </div>
      <ConfirmModal
        title={"Do you want to proceed?"}
        bodyText={"Basket Orders will be cleared if you change the Instrument Selection?"}
        show={show}
        setShow={(val) => setShow(val)}
        handleClose={() => setShow(false)}
        onClickHandle={() => onClickHandle()}
      />

      <TrialStatusModal
        open={trialExpiryInfo.open}
        type={trialExpiryInfo.type}
        expiryDate={trialExpiryInfo.expiryDate}
        productName={trialExpiryInfo.productName}
        onClose={() => setTrialExpiryInfo({ ...trialExpiryInfo, open: false })}
      />

      <BrokerPurposeModal
        brokers={brokersList}
        show={showBrokerPurposeModal}
        onComplete={() => setShowBrokerPurposeModal(false)}
      />


    </div>
  );
};

export default MainLayout;